var map = {
	"./facebook.svg": 1450,
	"./insta-fb.svg": 1451,
	"./instagram.svg": 1452,
	"./meta.svg": 1453,
	"./snapchat-logo.svg": 1454,
	"./snapchat.svg": 1455,
	"./tiktok.svg": 1456,
	"./tiktok_black.svg": 1457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1816;